import React, { useState, useEffect, useRef } from "react";
import BackgroundVideo from "../../assets/welcomeVideo.mp4";
import { useNavigate } from "react-router-dom";

const AnalyticsLogin = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [usernameError, setUsernameError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [resendDisabled, setResendDisabled] = useState(true);
  const [timer, setTimer] = useState(180);

  const otpInputRefs = useRef([]);

  // const companyEmailRegex = /^[^\s@]+@conquerlifeco\.com$/i;
  const companyEmailRegex = /^[^\s@]+@(conquerlifeco\.com|conquerlife\.io)$/i;

  useEffect(() => {
    let intervalId;
    if (isOtpSent && timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
      if (intervalId) clearInterval(intervalId);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isOtpSent, timer]);

  const handleInputChange = (text) => {
    setUsername(text);
    if (companyEmailRegex.test(text)) {
      setUsernameError("");
    } else if (text.length > 0) {
      setUsernameError("Please use your company email address.");
    }
  };

  // In the handleLogin function, replace the setTimeout with:

  const handleLogin = async () => {
    if (!username.trim()) {
      setUsernameError("Company email is required.");
      return;
    }
    if (!companyEmailRegex.test(username)) {
      setUsernameError("Please use your Company email address.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch("/api/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: username }),
      });

      const data = await response.json();

      if (data.success) {
        setIsOtpSent(true);
        setTimer(180);
        setResendDisabled(true);
        // Optionally show success message
        console.log("OTP sent successfully");
      } else {
        setUsernameError(data.error || "Failed to send verification code");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setUsernameError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // const handleLogin = async () => {
  //   if (!username.trim()) {
  //     setUsernameError("Company email is required.");
  //     return;
  //   }
  //   if (!companyEmailRegex.test(username)) {
  //     setUsernameError("Please use your @conquerlifeco.com email address.");
  //     return;
  //   }

  //   setIsLoading(true);
  //   // Simulate API call
  //   setTimeout(() => {
  //     setIsLoading(false);
  //     setIsOtpSent(true);
  //     setTimer(180);
  //     setResendDisabled(true);
  //   }, 1000);
  // };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    setOtpError("");

    if (value && index < 5) {
      otpInputRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  // const handleConfirmLogin = async () => {
  //   const otpValue = otp.join("");
  //   if (otpValue.length < 6) {
  //     setOtpError("Verification code is required.");
  //     return;
  //   }

  //   setIsLoading(true);
  //   // Simulate API call
  //   setTimeout(() => {
  //     setIsLoading(false);
  //     navigate("/dashboard");
  //   }, 1000);
  // };

  // In the handleConfirmLogin function, replace the setTimeout with:

  const handleConfirmLogin = async () => {
    const otpValue = otp.join("");
    if (otpValue.length < 6) {
      setOtpError("Verification code is required.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch("/api/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: username, otp: otpValue }),
      });

      const data = await response.json();

      if (data.success) {
        // Store auth token
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("userEmail", data.user.email);

        // Navigate to dashboard
        navigate("/dashboard");
      } else {
        setOtpError(data.error || "Invalid verification code");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // const onResendPressed = async () => {
  //   setIsLoading(true);
  //   setTimeout(() => {
  //     setIsLoading(false);
  //     setOtp(["", "", "", "", "", ""]);
  //     setOtpError("");
  //     setResendDisabled(true);
  //     setTimer(180);
  //     alert("A new code has been sent.");
  //   }, 1000);
  // };

  // In the onResendPressed function, replace the setTimeout with:

  const onResendPressed = async () => {
    setIsLoading(true);

    try {
      const response = await fetch("/api/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: username }),
      });

      const data = await response.json();

      if (data.success) {
        setOtp(["", "", "", "", "", ""]);
        setOtpError("");
        setResendDisabled(true);
        setTimer(180);
        alert("A new verification code has been sent to your email.");
      } else {
        setOtpError(data.error || "Failed to resend code");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      setOtpError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      minHeight: "100vh",
      overflow: "hidden",
      background:
        "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f1e 100%)",
    },
    animatedBackground: {
      position: "absolute",
      inset: 0,
      opacity: 0.2,
    },
    gradientPulse: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(90deg, #3b82f6 0%, #9333ea 100%)",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    },
    video: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      opacity: 1, // Changed from 0.3
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0)", // Changed from 0.4
    },
    contentWrapper: {
      position: "relative",
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "24px",
    },
    innerContainer: {
      width: "100%",
      maxWidth: "448px",
    },
    logoSection: {
      textAlign: "center",
      marginBottom: "40px",
    },
    logoWrapper: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "24px",
    },
    logo: {
      width: "128px",
      height: "128px",
      //   backgroundColor: "white",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(10px)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow:
        "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    },
    logoImage: {
      width: "90%", // Slightly smaller to add padding
      height: "90%",
      objectFit: "contain", // Shows full logo, no cropping
      borderRadius: "50%",
    },
    logoText: {
      fontSize: "36px",
      fontWeight: "bold",
      color: "#374151",
    },
    title: {
      color: "white",
      fontSize: "30px",
      fontWeight: "900",
      letterSpacing: "0.05em",
      marginBottom: "8px",
    },
    subtitle: {
      color: "white",
      fontSize: "14px",
      fontWeight: "600",
      letterSpacing: "0.05em",
    },
    formContainer: {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(10px)",
      borderRadius: "24px",
      padding: "32px",
      boxShadow:
        "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
    },
    inputGroup: {
      marginBottom: "24px",
    },
    label: {
      display: "block",
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
      marginBottom: "12px",
      letterSpacing: "0.05em",
    },
    input: {
      width: "100%",
      padding: "14px 20px",
      borderRadius: "9999px",
      backgroundColor: "white",
      color: "#1f2937",
      fontSize: "16px",
      border: "none",
      outline: "none",
      boxSizing: "border-box",
    },
    inputDisabled: {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    errorContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: "12px",
      color: "#fca5a5",
      fontSize: "14px",
    },
    errorIcon: {
      marginRight: "8px",
      width: "16px",
      height: "16px",
    },
    helperText: {
      color: "white",
      fontSize: "12px",
      marginTop: "12px",
      opacity: 0.8,
    },
    otpContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: "8px",
      marginBottom: "16px",
    },
    otpInput: {
      flex: 1, // Changed from fixed width
      minWidth: 0, // Allows shrinking
      maxWidth: "60px", // Maximum size
      height: "48px",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "600",
      borderRadius: "12px",
      backgroundColor: "white",
      color: "#1f2937",
      border: "none",
      outline: "none",
    },
    retryContainer: {
      textAlign: "center",
      marginTop: "20px",
    },
    retryButton: {
      color: "white",
      textDecoration: "underline",
      fontStyle: "italic",
      fontSize: "14px",
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      padding: "8px",
      marginBottom: "12px",
    },
    resendButton: {
      textDecoration: "underline",
      fontSize: "14px",
      backgroundColor: "transparent",
      border: "none",
      padding: "8px",
      display: "block",
      margin: "0 auto",
    },
    resendEnabled: {
      color: "white",
      cursor: "pointer",
    },
    resendDisabled: {
      color: "#9ca3af",
      cursor: "not-allowed",
    },
    actionButton: {
      width: "100%",
      backgroundColor: "white",
      color: "#111827",
      fontWeight: "bold",
      fontSize: "18px",
      padding: "16px",
      borderRadius: "9999px",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      boxShadow:
        "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      transition: "all 0.3s",
    },
    buttonDisabled: {
      opacity: 0.5,
      cursor: "not-allowed",
    },
    spinner: {
      width: "24px",
      height: "24px",
      border: "2px solid #111827",
      borderTopColor: "transparent",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    footer: {
      color: "white",
      textAlign: "center",
      fontSize: "12px",
      marginTop: "24px",
      opacity: 0.7,
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 0.2; }
            50% { opacity: 0.3; }
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          button:hover:not(:disabled) {
            opacity: 0.9;
          }
          input:focus {
            box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
          }
        `}
      </style>

      {/* Animated Background Pattern */}
      <div style={styles.animatedBackground}>
        <div style={styles.gradientPulse}></div>
      </div>

      {/* Video Background */}
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        style={styles.video}
      >
        <source src={BackgroundVideo} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div style={styles.overlay} />

      {/* Content */}
      <div style={styles.contentWrapper}>
        <div style={styles.innerContainer}>
          {/* Logo and Title */}
          <div style={styles.logoSection}>
            <div style={styles.logoWrapper}>
              <div style={styles.logo}>
                <img
                  src="https://conquerlifepublicbucket.s3.us-east-1.amazonaws.com/conquerLifeLogo.png"
                  alt="Conquer Life Logo"
                  style={styles.logoImage}
                />
              </div>
            </div>
            <h1 style={styles.title}>CONQUER LIFE</h1>
            <p style={styles.subtitle}>Analytics Dashboard</p>
          </div>

          {/* Form Container */}
          <div style={styles.formContainer}>
            {/* Company Email Input */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>COMPANY EMAIL</label>
              <input
                type="email"
                value={username}
                onChange={(e) => handleInputChange(e.target.value)}
                disabled={isOtpSent}
                placeholder="Enter your email here"
                style={{
                  ...styles.input,
                  ...(isOtpSent ? styles.inputDisabled : {}),
                }}
              />
              {usernameError && (
                <div style={styles.errorContainer}>
                  <svg
                    style={styles.errorIcon}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span style={{ fontWeight: "600" }}>{usernameError}</span>
                </div>
              )}
              {/* {!isOtpSent && !username && (
                <p style={styles.helperText}>
                  Only Conquer Life Co. Members are allowed
                </p>
              )} */}
            </div>

            {/* OTP Input */}
            {isOtpSent && (
              <div style={styles.inputGroup}>
                <label style={styles.label}>VERIFICATION CODE</label>
                <div style={styles.otpContainer}>
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (otpInputRefs.current[index] = el)}
                      type="text"
                      inputMode="numeric"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      style={styles.otpInput}
                    />
                  ))}
                </div>
                {otpError && (
                  <div style={styles.errorContainer}>
                    <svg
                      style={styles.errorIcon}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span style={{ fontWeight: "600" }}>{otpError}</span>
                  </div>
                )}

                {/* Retry and Resend Options */}
                <div style={styles.retryContainer}>
                  <button
                    onClick={() => {
                      setIsOtpSent(false);
                      setOtp(["", "", "", "", "", ""]);
                      setOtpError("");
                    }}
                    style={styles.retryButton}
                  >
                    Made a mistake? Re-try by tapping me!
                  </button>
                  <button
                    onClick={onResendPressed}
                    disabled={resendDisabled}
                    style={{
                      ...styles.resendButton,
                      ...(timer > 0
                        ? styles.resendDisabled
                        : styles.resendEnabled),
                    }}
                  >
                    {`Resend Code in ${String(Math.floor(timer / 60)).padStart(
                      2,
                      "0"
                    )}:${String(timer % 60).padStart(2, "0")}`}
                  </button>
                </div>
              </div>
            )}

            {/* Action Button */}
            <button
              onClick={isOtpSent ? handleConfirmLogin : handleLogin}
              disabled={isLoading || (!!usernameError && !isOtpSent)}
              style={{
                ...styles.actionButton,
                ...(isLoading || (!!usernameError && !isOtpSent)
                  ? styles.buttonDisabled
                  : {}),
              }}
            >
              {isLoading ? (
                <div style={styles.spinner} />
              ) : (
                <>
                  <span>{isOtpSent ? "LOGIN" : "GET CODE"}</span>
                  <svg
                    style={{ width: "24px", height: "24px" }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M7 17L17 7M17 7H7M17 7v10"
                    />
                  </svg>
                </>
              )}
            </button>
          </div>

          {/* Footer */}
          <p style={styles.footer}>
            Secure authentication powered by CONQUER LIFE
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsLogin;
